import { useState } from "react";

export default function useHover(
    ignoreHover: (ev: React.MouseEvent) => boolean,
): [boolean, { onMouseOver: () => void; onMouseLeave: () => void; onMouseMove: (ev: React.MouseEvent) => void }] {
    const [hovered, setHoverState] = useState(false);

    const props = {
        onMouseOver: () => setHoverState(true),
        onMouseLeave: () => setHoverState(false),
        onMouseMove: (ev: React.MouseEvent): void => {
            setHoverState(!ignoreHover(ev));
        },
    };

    return [hovered, props];
}
